// @ts-check
import React from 'react';
import { IconProp } from '@fortawesome/fontawesome-svg-core'; // eslint-disable-line no-unused-vars
import { CircleIcon } from 'preferral-ui/components/CircleIcon';
import { FAIcon } from 'preferral-ui/components/FAIcon';

/** @typedef {{
  icon: IconProp;
  title: string;
  onClose(): void;
  color?: string;
}} ModalHeaderProps */

/** @type { React.FC<ModalHeaderProps> } */
export const ModalHeader = (props) => {
  const { icon, title, onClose, color = 'blue' } = props;

  return (
    <div className="ModalHeader">
      <div className="flex items-center justify-between px-6 py-4">
        <div className="flex items-center">
          <div>
            <CircleIcon icon={icon} color={color} />
          </div>
          <div className="ml-4">
            <h4 className="text-2xl text-gray-700">{title}</h4>
          </div>
        </div>
        <button
          className="hover:text-gray-700 text-xl text-gray-500"
          onClick={onClose}
        >
          <FAIcon icon="times" />
        </button>
      </div>
    </div>
  );
};
